import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { FormHelperText, Grid, ListItemIcon } from "@material-ui/core";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Menu } from "@material-ui/icons";
import { StyledTextField } from "../../Components/TextField/TextField";

function DraggableFeeds({ handleOnDragEnd, items, handleInputChange }) {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "90%",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    itemIcon: {
      paddingRight: "15px",
      minWidth: "20px",
      lineHeight: "10px",
    },
  }));

  const classes = useStyles();
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={12}>
        <FormHelperText style={{ marginTop: "20px", marginBottom: "-20px" }}>Additonal Fields</FormHelperText>
        <DragDropContext onDragEnd={handleOnDragEnd}>
          <Droppable droppableId="items">
            {(provided) => (
              <ul
                style={{ paddingLeft: "0px", listStyleType: "none" }}
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {items.map((field, index) => {
                  return (
                    <Draggable key={index} draggableId={index.toString()} index={index}>
                      {(provided) => (
                        <li
                          {...provided.dragHandleProps}
                          {...provided.draggableProps}
                          ref={provided.innerRef}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <StyledTextField
                              InputLabelProps={{
                                style: { color: "rgba(0,0,0,.6)" },
                                shrink: true, // resolves known issue with mui shrink state causing overlapping text
                              }}
                              placeholder={field.name}
                              label={field.name}
                              defaultValue=""
                              variant="standard"
                              fullWidth
                              value={field.val}
                              onChange={(e) => handleInputChange(index, e)}
                            />
                            <ListItemIcon className={classes.itemIcon}>
                              <Menu />
                            </ListItemIcon>
                          </div>
                        </li>
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </ul>
            )}
          </Droppable>
        </DragDropContext>
      </Grid>
    </Grid>
  );
}

export default DraggableFeeds;
